import { render, staticRenderFns } from "./AdminKeywordList.vue?vue&type=template&id=92fe50d4&"
import script from "./AdminKeywordList.vue?vue&type=script&lang=js&"
export * from "./AdminKeywordList.vue?vue&type=script&lang=js&"
import style0 from "./AdminKeywordList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports